import { Z as l } from "./chunk-lit-element-D3OkYgeM.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: m } = l, B = (e) => e.strings === void 0, o = () => document.createComment(""), g = (e, i, t) => {
  var f;
  const r = e._$AA.parentNode, $ = i === void 0 ? e._$AB : i._$AA;
  if (t === void 0) {
    const _ = r.insertBefore(o(), $), s = r.insertBefore(o(), $);
    t = new m(_, s, e, e.options);
  } else {
    const _ = t._$AB.nextSibling, s = t._$AM, n = s !== e;
    if (n) {
      let A;
      (f = t._$AQ) == null || f.call(t, e), t._$AM = e, t._$AP !== void 0 && (A = e._$AU) !== s._$AU && t._$AP(A);
    }
    if (_ !== $ || n) {
      let A = t._$AA;
      for (; A !== _; ) {
        const c = A.nextSibling;
        r.insertBefore(A, $), A = c;
      }
    }
  }
  return t;
}, p = (e, i, t = e) => (e._$AI(i, t), e), d = {}, x = (e, i = d) => e._$AH = i, a = (e) => e._$AH, b = (e) => {
  var r;
  (r = e._$AP) == null || r.call(e, !1, !0);
  let i = e._$AA;
  const t = e._$AB.nextSibling;
  for (; i !== t; ) {
    const $ = i.nextSibling;
    i.remove(), i = $;
  }
};
export {
  b as M,
  B as f,
  x as m,
  a as p,
  g as r,
  p as v
};
